import { Typography } from 'antd';
import { Link } from 'react-router-dom';
import { COMPANY } from '@shared/legal';

const { Text } = Typography;

/**
 * Подвал со ссылками на юр.документы и краткими реквизитами.
 *
 * Вставляется и в публичный LegalLayout, и в CabinetLayout — чтобы
 * пользователь и проверяющий от ЮKассы видели реквизиты и могли попасть
 * на политику/соглашение откуда угодно.
 *
 * LEGAL-OOO: реквизиты ООО «РИЧ ЧАТ» (ОГРН + ИНН) вместо прежних
 * реквизитов ИП (ОГРНИП).
 *
 * Стиль «Графит»: маленький приглушённый текст, без ярких акцентов,
 * тонкая верхняя граница для отделения от контента.
 */
export function LegalFooter() {
  const linkStyle: React.CSSProperties = {
    color: '#6B7280',
    textDecoration: 'none',
    fontSize: 12,
  };

  return (
    <footer
      style={{
        borderTop: '1px solid #E5E7EB',
        background: '#FFFFFF',
        padding: '16px 24px',
      }}
    >
      <div
        style={{
          maxWidth: 1100,
          margin: '0 auto',
          display: 'flex',
          flexWrap: 'wrap',
          gap: 12,
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <div
          style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: 16,
            rowGap: 6,
          }}
        >
          <Link to="/pricing" style={linkStyle}>
            Тарифы
          </Link>
          <Link to="/legal/terms" style={linkStyle}>
            Пользовательское соглашение
          </Link>
          <Link to="/legal/privacy" style={linkStyle}>
            Политика конфиденциальности
          </Link>
          <Link to="/legal/requisites" style={linkStyle}>
            Реквизиты
          </Link>
        </div>
        <Text type="secondary" style={{ fontSize: 11 }}>
          {COMPANY.shortName} · ИНН {COMPANY.inn} · ОГРН {COMPANY.ogrn}
        </Text>
      </div>
    </footer>
  );
}
